import  gql  from 'graphql-tag'

export const sessions = gql`query{
        sessions{
        edges{
            node{
            id
            created
            revoked
            expirationTime
            user{
                name
                email
                surname
                username
                group{
                id
                name
                }
            }
            }
        }
        }
    }`;